import { render } from "./ChangeAuth0AssociatedMembership.vue?vue&type=template&id=2138ef26"
import script from "./ChangeAuth0AssociatedMembership.vue?vue&type=script&lang=js"
export * from "./ChangeAuth0AssociatedMembership.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__